'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar, AvatarFallback } from '@extern/ui/avatar';
import { Button } from '@extern/ui/button';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@extern/ui/form';
import { Input } from '@extern/ui/input';
import { Text } from '@extern/ui/text';
import { zodResolver } from '@hookform/resolvers/zod';
import { MailboxIcon } from '@phosphor-icons/react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { emailSchema } from '@/infra/schemas/auth';
import { useSignIn } from '../_hooks/use-sign-in';
import { useSignInFlowStore } from '../_hooks/use-sign-in-flow-store';
const ForgotPasswordSchema = z.object({
  identifier: emailSchema
});
const cardClassName = 'flex w-full sm:w-[358px] max-w-full flex-col items-center gap-6 overflow-clip rounded-3xl border border-role-outline-subtle bg-white p-6';
export function SignInForgotPasswordExperiment() {
  const $ = _c(28);
  const {
    onSendResetCode,
    onGoBack,
    fetchStatus
  } = useSignIn();
  const experimentIdentifier = useSignInFlowStore(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = zodResolver(ForgotPasswordSchema);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = experimentIdentifier ?? "";
  let t2;
  if ($[1] !== t1) {
    t2 = {
      resolver: t0,
      defaultValues: {
        identifier: t1
      },
      mode: "onChange"
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const form = useForm(t2);
  let t3;
  if ($[3] !== onSendResetCode) {
    t3 = async function handleSubmit(data) {
      await onSendResetCode(data.identifier);
    };
    $[3] = onSendResetCode;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleSubmit = t3;
  let t4;
  if ($[5] !== form || $[6] !== handleSubmit) {
    t4 = form.handleSubmit(handleSubmit);
    $[5] = form;
    $[6] = handleSubmit;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex w-full flex-col items-center justify-center gap-6 text-center"><Avatar size="48"><AvatarFallback className="bg-role-info-container text-role-on-info-container" size="48" variant="icon"><MailboxIcon size={20} /></AvatarFallback></Avatar><Text className="text-role-on-background" title="lg">Enter your email to receive a reset code</Text></div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== form.control) {
    t6 = <FormField control={form.control} name="identifier" render={_temp2} />;
    $[9] = form.control;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onGoBack) {
    t7 = <Button appearance="outlined" className="flex-1" color="info" onClick={onGoBack} type="button">Return</Button>;
    $[11] = onGoBack;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = fetchStatus === "fetching" || form.formState.isSubmitting || !form.formState.isValid;
  const t9 = fetchStatus === "fetching";
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <Button appearance="filled" className="flex-1" color="info" disabled={t8} isLoading={t9} type="submit">Continue</Button>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t7) {
    t11 = <div className="flex w-full gap-4">{t7}{t10}</div>;
    $[16] = t10;
    $[17] = t7;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t6) {
    t12 = <div className="flex w-full flex-col gap-4">{t6}{t11}</div>;
    $[19] = t11;
    $[20] = t6;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t4) {
    t13 = <form className={cardClassName} onSubmit={t4}>{t5}{t12}</form>;
    $[22] = t12;
    $[23] = t4;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== form || $[26] !== t13) {
    t14 = <Form {...form}>{t13}</Form>;
    $[25] = form;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
}
function _temp2(t0) {
  const {
    field
  } = t0;
  return <FormItem><FormControl><Input autoCapitalize="none" autoComplete="email" autoCorrect="off" data-cy="forgot-email" id="forgot-email" placeholder="joe@extern.com" type="email" {...field} /></FormControl><FormMessage /></FormItem>;
}
function _temp(s) {
  return s.experimentIdentifier;
}